import DeleteIcon from '@atlaskit/icon/core/delete';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { analyticsClient } from '@databases/analytics';
import { messages } from '@databases/intl/messages';
import React from 'react';

import { deleteFields } from '../actions/delete-fields';
import { onMouseEnterDeleteFieldButton } from '../actions/on-mouse-enter-delete-field-button';
import { onMouseLeaveDeleteFieldButton } from '../actions/on-mouse-leave-delete-field-button';
import { type MenuItemBuilder, SELECT_VALUE_MENU_ACTIONS } from '../types';
import { ElementBeforeIconWrapper } from '../ui/components';

export const deleteFieldsMenuItem: MenuItemBuilder = ({
  capabilities: { canDeleteFields },
  contentId,
  dialogs: { showDialog },
  fieldId,
  formatMessage,
  isHoverDeleteFieldsButton,
  panelManager,
  selectedFieldIds,
  selectedFieldsCount,
}) => {
  const { fieldId: panelFieldId } = panelManager.getData('FieldSettingsPanel') || {};

  return {
    isEnabled: () => canDeleteFields,
    menuItem: {
      key: SELECT_VALUE_MENU_ACTIONS.DELETE_FIELDS,
      content: formatMessage(messages['field-actions.delete'], {
        fieldCount: selectedFieldsCount.toString(),
      }),
      onClick: () =>
        deleteFields({
          contentId,
          formatMessage,
          client: analyticsClient,
          fieldId: fieldId,
          hidePanel: panelManager.hidePanel,
          showDialog,
          panelFieldId,
        }),
      closeOnClick: true,
      onMouseEnter: () => onMouseEnterDeleteFieldButton(contentId, selectedFieldIds),
      onMouseLeave: () => onMouseLeaveDeleteFieldButton(selectedFieldIds),
      elemBefore: (
        <ElementBeforeIconWrapper>
          <DeleteIcon
            label=""
            spacing="spacious"
            color={
              isHoverDeleteFieldsButton
                ? token('color.icon.danger', colors.R500)
                : undefined
            }
          />
        </ElementBeforeIconWrapper>
      ),
    },
  };
};
